import { selectIsSuspended } from '@/features/auth/store/authSlice';
import { Banner } from '@/lib/ui/molecules/Banner';
import { useAppSelector } from '@/store/hooks';

import { useCreateCustomerPortalSession } from '../hooks';

export function SuspensionBanner() {
  const isSuspended = useAppSelector(selectIsSuspended);
  const [createPortalSession, { isLoading }] = useCreateCustomerPortalSession();

  if (!isSuspended) return null;

  const handleUpdatePayment = async () => {
    const result = await createPortalSession().unwrap();
    window.location.href = result.portal_url;
  };

  return (
    <Banner
      variant="destructive"
      action={{ label: 'Update Payment', onClick: handleUpdatePayment, disabled: isLoading }}
    >
      <span>
        <span className="font-medium">Account suspended.</span> A payment issue was detected. Your
        API keys are disabled until resolved.{' '}
        <a href="mailto:support@moveris.com" className="font-medium underline hover:no-underline">
          Contact support
        </a>
      </span>
    </Banner>
  );
}
